/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import {
  ElLayoutComponent,
  ElLayoutColumnComponent,
  ElLayoutFooterComponent,
  ElLayoutHeaderComponent,
} from './layout.component';

import { ElRestoreScrollTopHelper } from './restore-scroll-top.service';

const EL_LAYOUT_COMPONENTS = [
  ElLayoutComponent,
  ElLayoutColumnComponent,
  ElLayoutFooterComponent,
  ElLayoutHeaderComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
  ],
  declarations: [
    ...EL_LAYOUT_COMPONENTS,
  ],
  providers: [
    ElRestoreScrollTopHelper,
  ],
  exports: [
    ...EL_LAYOUT_COMPONENTS,
  ],
})
export class ElLayoutModule { }
